var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center pt-6"},[_c('img',{staticClass:"vw-logo",attrs:{"alt":"viva.com","src":require("@/assets/images/logos/viva-com-logo-circle.svg")}})])
}]

export { render, staticRenderFns }